//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
//Action types
import {
    MAINTENANCE_WARNINGS_DETAILS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    maintenanceWarningsDetailsResult,
} from 'Redux/actions';
function* getGadgetData({ payload }) {
    try {
        let QUERY = `
            query getGadgetData ($id: String!, $query: GadgetDataQuery) {
                result: getGadgetData (id: $id, query: $query)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload.data,
            endpoints.GRAPHQL_GENERAL,
        );
        let result = []
        try {
            result = data?.result && typeof data?.result === 'string' ? JSON.parse(data?.result) : null
        } catch (error) { }
        yield put(maintenanceWarningsDetailsResult(result))
    } catch (exc) {
        yield put(maintenanceWarningsDetailsResult({
            items: [],
            total: 0
        }))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/maintenanceWarningsDetails/redux/saga', 'getGadgetData');
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(MAINTENANCE_WARNINGS_DETAILS_REQUEST, getGadgetData);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}